<script>
  import { query } from "./stores.js";

  const params = (new URL(document.location)).searchParams;
  let term = "";
  function search() {
    if (term) {
      query.SearchableText = term;
    } else {
      delete query.SearchableText;
    }
    query.set(query);
  }
  term = params.get("SearchableText") || "";
  if (term) {
    // Immediately search on the parameter that we got from the search box.
    search();
  }
</script>

<div class="faceted-widget">
  <fieldset class="widget-fieldset">
    <legend>Zoeken</legend>
    <form action="#" method="GET" on:submit={search}>
      <!-- A hidden submit will catch pressing Enter -->
      <input style="display: none" type="submit" id="submitbtn"  />
      <div class="input-group">
        <input
          type="text"
          bind:value={term}
          placeholder="Type een zoekterm"
        />
        <span class="input-group-button float-end">
          <button class="btn btn-mina-green"> Zoeken </button>
        </span>
      </div>
    </form>
  </fieldset>
</div>

